import styled from '@emotion/styled'
import Link from 'next/link'

import Button from '../../Button'
import HoverableItem from '../../HoverableItem'
import { HelpDeskLogoIcon, InfoIcon } from '../../icons'
import { useIsOnboarding } from 'hooks/useIsOnboarding'
import { useTracking } from 'hooks/useTracking'
import { EVENT_NAMES } from 'lib/tracking'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.light.surface};
	gap: ${({ theme }) => theme.spaces.space2};
	padding: ${({ theme }) => theme.spaces.space4};
	border-radius: inherit;
	border: 1px solid ${({ theme }) => theme.colors.light.borderColor};
	${({ theme }) => theme.typography.caption};
`

const BaseLink = styled(Link)`
	text-decoration: none;
	margin-left: ${({ theme }) => theme.spaces.space4};
`

const ManageButton = styled(Button)`
	font-weight: 600;
	padding: ${({ theme }) => (theme.isMobile ? theme.spaces.space2 : theme.spaces.space3)};
	background-color: ${({ theme }) => theme.colors.light.surfaceDecorative};
	border-radius: ${({ theme }) => theme.borderRadiuses.md};
`

const HoverableInfo = styled(HoverableItem)`
	margin-left: auto;
`

function HelpDeskEnabledInputInset() {
	const track = useTracking()
	const isOnboarding = useIsOnboarding()

	return (
		<Wrapper>
			<HelpDeskLogoIcon />
			HelpDesk
			{!isOnboarding && (
				<BaseLink href="/configurator/widget-content/helpdesk">
					<ManageButton
						kind="secondary"
						type="button"
						onClick={() => track(EVENT_NAMES.HELPDESK_MANAGE_CLICKED)}
						mediumDesktop
					>
						Manage
					</ManageButton>
				</BaseLink>
			)}
			<HoverableInfo
				position={{ bottom: '37px', right: 0 }}
				title="Visit HelpDesk app to reply to your customers' inquiries."
			>
				<InfoIcon />
			</HoverableInfo>
		</Wrapper>
	)
}

export default HelpDeskEnabledInputInset
